<template lang="pug">
v-form(ref="formEl")
  .title 個人資料同意聲明
  v-btn(@click="dialog=true") 個人資料同意聲明
  v-dialog(v-model="dialog" width="500")
    v-card
      v-card-title 隱私權及安全政策
      v-card-text.dialog-text 教育部(以下簡稱本部)基於計畫申請目的需蒐集您的姓名、單位及公務聯絡電話、信箱，相關資料僅供本部於當年度本計畫聯繫之用，使用地區為台灣。您可以就其個人資料依個人資料保護法第三條規定行使查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用、請求刪除。請務必確實填寫各項欄位，以免影響您申請的權益，如您同意本告知內容，請再行填寫以下之內容。
  v-radio-group(
    v-model="isAgree" 
    :rules="rules.agree"
  ).is-agree
    v-radio(label="同意" :value="true")
    v-radio(label="不同意" :value="false")
  .apply-process-block 申請流程說明
    .imgs
      img(v-for="info in applyProcessInfo" :key="info.id" :src="info.src")
  .division-block 所屬主管教育行政機關
    v-select(:items="cities" label="行政區域" v-model="divisionCity" 
      item-text="name", 
      item-value="name"
      :rules="rules.require"
    )
    v-text-field(label="學校名稱" v-model="schoolName" :rules="rules.require")
  v-radio-group(v-model="schoolType" label="學校類型").school-type
    v-radio(label="偏遠" value="偏遠")
    v-radio(label="特殊偏遠" value="特殊偏遠") 
    v-radio(label="極度偏遠" value="極度偏遠")
  .attend-block
    .title 請選擇參與人數
    .alert 此活動最大人數限制: {{max_people}} 人
    v-row
      v-col(md="4" cols="12")
        v-text-field(label="參與的老師" v-model.number="attend.teacher" type="number" min="0"
          :rules="rules.people"
        )
      v-col(md="4" cols="12")
        v-text-field(label="參與的學生" v-model.number="attend.student" type="number" min="0"
          :rules="rules.people"
        )
      v-col(md="4" cols="12")
        v-text-field(label="其他參與人" v-model.number="attend.other" type="number" min="0"
          :rules="rules.people"
        )
    .total-people 預計參訪總人數 
      .people(:class="{err: totalPeopleErrorMsg != null}") {{totalPeople}} 位
        .error-msg {{totalPeopleErrorMsg}}
  .contact-block  承辦人/聯絡人
    v-row
      v-col(lg="4" md="6" cols="12")
        v-text-field(label="姓名" v-model="contact.name" type="text" 
          :rules="rules.require"
        )
      v-col(lg="4" md="6" cols="12")
        v-text-field(label="電話" v-model="contact.phone" type="number"
          :rules="[...rules.require, ...rules.phone]"
        )
      v-col(lg="4" cols="12")
        v-text-field(label="Email" v-model="contact.email" type="text"
          :rules="[...rules.require, ...rules.email]"
        )
  .session-block
    .title 場次時間說明
    .info {{sessionData.description}}
    label 請選擇場次日期、時間
    v-menu(
      top offset-x 
      :close-on-content-click="false"
    )
      template(v-slot:activator="{ on, attrs }")
        v-text-field(
          v-model="pickDate" type="date" readonly v-on="on" v-bind="attrs"
        )
      v-date-picker(
        :showCurrent="false"
        v-model="pickDate"
        :allowed-dates="allowedDates"
        :min="eventFrom"
        :max="eventTo"
      )
    v-select(
      :items="selectedTimeList"
      :rules="rules.require"
      label="場次" v-model="pickTime"
    )
</template>

<script>
export default {
  comments: {},
  props: {
    eventTo: {
      type: String,
      default: ''
    },
    eventFrom: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    sessionData: {
      type: Object,
      default: null
    },
    max_people: {
      type: [Number, String],
      default: null
    },
    place: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      isAgree: null,
      divisionCity: null,
      schoolName: '',
      maxPeople: 0,
      attend: {
        teacher: null,
        student: null,
        other: null
      },
      contact: {
        name: '',
        phone: '',
        email: ''
      },
      pickDate: null,
      pickTime: null,
      schoolType: '',
      rules: {
        email: [value => /.+@.+/.test(value) || 'email 格式錯誤'],
        phone: [value => !isNaN(+value) || '需要輸入數字'],
        agree: [value => value === true || '請勾選授權同意, 如有疑問請聯繫主辦單位'],
        require: [value => !!value || '此欄位不可為空'],
        people: [value => +value >= 0 || '人數不能為負值']
      },
      applyProcessInfo: [
        {
          id: 1,
          src: require('../../assets/activity/culture_description_img_1.png'),
        },
        {
          id: 2,
          src: require('../../assets/activity/culture_description_img_2.png'),
        },
        {
          id: 3,
          src: require('../../assets/activity/culture_description_img_3.png'),
        },
        {
          id: 4,
          src: require('../../assets/activity/culture_description_img_4.png'),
        }
      ],
      cities: [
        { id: 1, 'name': '基隆市' }, { id: 2, 'name': '新北市' }, { id: 3, 'name': '桃園縣' },
        { id: 4, 'name': '新竹市' }, { id: 5, 'name': '新竹縣' }, { id: 6, 'name': '苗栗縣' },
        { id: 7, 'name': '台中市' }, { id: 8, 'name': '彰化縣' }, { id: 9, 'name': '南投縣' },
        { id: 10, 'name': '雲林縣' }, { id: 11, 'name': '嘉義市' }, { id: 12, 'name': '嘉義縣' },
        { id: 13, 'name': '台南市' }, { id: 14, 'name': '高雄市' }, { id: 15, 'name': '屏東縣' },
        { id: 16, 'name': '台東縣' }, { id: 17, 'name': '花蓮縣' }, { id: 18, 'name': '宜蘭縣' },
        { id: 19, 'name': '澎湖縣' }, { id: 20, 'name': '金門縣' }, { id: 21, 'name': '連江縣' }
      ]
    }
  },
  computed: {
    selectedTimeList() {
      if (this.pickDate == null) return null
      const { openDayType } = this.sessionData

      if (openDayType === 'custom') {
        const timeTarget = this.sessionData[openDayType].find(e => e.date.includes(this.pickDate))
        return timeTarget.timeArray.map(e => e.time)
      }
      if (openDayType.toLowerCase() === 'weekday') {
        const pickDay = `${new Date(this.pickDate).getDay()}`
        const timeTargets = this.sessionData.weekDay.filter(e => e.day.includes(pickDay))
        return timeTargets.reduce((list, curr) => {
          list = list.concat(curr.timeArray.map(e => e.time))
          return [...new Set(list)]
        }, [])
        // timeArray.map(e => e.time)
      }
      // TODO: everDay
      if (openDayType.toLowerCase() === 'everyday') {
        return this.sessionData.everyDay.timeArray.map(e => e.time)
      }
    },
    totalPeople() {
      return Object.values(this.attend).reduce((sum, curr) => sum += +curr, 0)
    },
    totalPeopleErrorMsg() {
      if (this.totalPeople < 0) return '人數不能為負值'
      if (this.totalPeople === 0) return '請在上方輸入老師、學生、及其他參與人數'
      if (this.totalPeople > this.max_people) return '總人數超過場地上限'
    },
    apiValue() {
      const data = {
        date: this.pickDate,
        name: this.schoolName,
        time: this.pickTime,
        // order: {
        //   get: 1,
        //   open: false,
        //   options: [1,2,3]
        // },
        attend: {
          ...this.attend,
          total: this.totalPeople,
        },
        contact: {...this.contact},
        division: this.divisionCity,
        userRight: this.isAgree ? 'yes': 'no',
        school_type: this.schoolType
      }
      return data
    }
  },
  methods: {
    validate() {
      return this.$refs.formEl.validate()
    },
    allowedDates(value) {
      const { openDayType } = this.sessionData
      if (openDayType === 'custom') {
        const openDateList = this.sessionData.custom.reduce((list, curr) => {
          list = list.concat(curr.date)
          return [...new Set(list)]
        }, [])
        return !!openDateList.includes(value)
      }
      if (openDayType.toLowerCase() === 'everyday') {
        const { noDate, noHoliday } = this.sessionData.everyDay
        if (noDate && noDate.includes(value)) return false
        if (noHoliday === true && [0, 6].includes(new Date(value).getDay())) return false
        return true
      }
      if (openDayType.toLowerCase() === 'weekday') {
        const dayList = this.sessionData.weekDay.reduce((list, curr) => {
          list = list.concat(curr.day)
          return [...new Set(list)]
        }, [])
        const today = `${new Date(value).getDay()}`
        return dayList.includes(today)
      }
    },
  }
}
</script>

<style lang="sass" scoped>
.dialog-text
  line-height: 30px
  font-size: 16px
.v-picker
  background-color: #37474f !important
  color: black
.v-date-picker-table .v-btn.v-btn--active::deep
  background-color: #37474f !important
.apply-process-block
  .imgs
    display: flex
    justify-content: center
    flex-wrap: wrap
    img
      min-width: 300px
      width: 50%
      max-width: 500px
.contact-block
  margin-top: 20px
.session-block
  margin-top: 10px
  .title
    margin-bottom: 10px
  .info
    font-weight: 300
    color: rgba(black,0.87)
    margin-bottom: 30px
.attend-block
  .title
    margin-bottom: 10px
  .alert 
    margin-bottom: 10px
    font-size: 14px
  .total-people
    font-size: 14px
    color: rgba(black, 0.8)
.err
  color: red !important
</style>



// WEBPACK FOOTER //
// src/views/ApplicationForm/SchoolForm.vue